import {
  TextAlignment,
  TokenTextColor,
  TextTag,
} from '@volkswagen-onehub/components-core';
import React, {FC, useState} from 'react';
import {useHistory, useLocation} from 'react-router-dom';
import styled from 'styled-components';
import BackButtonSVG from '../components/BackButtonSVG';
import CloseButtonSVG from '../components/CloseButtonSVG';
import QuestionCloseDialog from '../components/CloseDialog';
import {WrapContentCenter} from '../components/ContentWrapperStyled';
import ProgressBar from '../components/StyledProgressBar';
import TypographyHeading from '../components/Typography/TypographyHeading';
import {QuestionData} from '../constants/questions';
import useQuestionStore, {
  parseQuestionIdWithIdentifier,
} from '../store/navigation';
import {useResultStore} from '../store/responses';
import {
  MultiSelectorQuestion,
  QUESTIONIDS,
  Question,
  SingleSelectorQuestion,
  SliderQuestion,
} from '../types/question';
import QuestionEightAddress from './QuestionEightAddress';
import QuestionElevenChargingWork from './QuestionElevenChargingWork';
import QuestionFiveTowingPreference from './QuestionFiveTowingPreference';
import QuestionFourPassenger from './QuestionFourPassenger';
import {QuestionFourteenResults} from './QuestionFourteenResults';
import {QuestionLanding} from './QuestionLanding';
import QuestionNineChargingType from './QuestionNineChargingType';
import QuestionOneName from './QuestionOneName';
import QuestionSevenVehicleFeaturesLong from './QuestionSevenVehicleFeatures';
import QuestionSixFitsYourTrade from './QuestionSixFitsYourTrade';
import QuestionTenChargingHome from './QuestionTenChargingHome';
import QuestionThirteenForm from './QuestionThirteenForm';
import QuestionThreeVehicleUse from './QuestionThreeVehicleUse';
import QuestionTwelveTravelDistance from './QuestionTwelveTravelDistance';
import QuestionTwoYourVehicle from './QuestionTwoYourVehicle';
// eslint-disable-next-line import/no-extraneous-dependencies
import {questionsManual} from '../constants/questionManual/questionManual';
import {generateResultsUrl} from '../helpers/resultSections';
import {ResultQuestions, SelectManualProps} from '../types/questionManuals';
import QuestionContainer from './QuestionContainer';
import {QuestionManual} from './questionManual';
import '../assets/css/question.css';
interface Props {
  onClose?: () => void;
}

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  color: var(--1-white-000, #fff);
  padding: 0 16px;
`;

export const QuestionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  flex: 1;
`;

const QuestionModal: FC<Props> = (props) => {
  const {onClose} = props;
  const {pathname, search} = useLocation();
  const history = useHistory();
  const {
    currentQuestion,
    goBack,
    setCurrentQuestion,
    questionType,
    setQuestionType,
    questionHistory,
    setQuestionHistory,
    popQuestionHistory,
  } = useQuestionStore();
  const {result} = useResultStore();
  const [isShowCloseDialog, setIsShowCloseDialog] = useState<boolean>(false);
  type QuestionId = (typeof QUESTIONIDS)[keyof typeof QUESTIONIDS];
  const [stepManual, setStepManual] = React.useState(1);
  const [resultsManual, setResultsManual] = React.useState<ResultQuestions[]>(
    [],
  );
  const [showResultVehicle, setShowResultVehicle] = useState(false);

  const onShowResultVehicle = () => {
    setShowResultVehicle(true);
  };
  const onHiddenResultVehicle = () => {
    setShowResultVehicle(false);
  };
  const renderQuestionMain = (questionId: QuestionId) => {
    switch (questionId) {
      case QUESTIONIDS.questionLanding:
        return <QuestionLanding />;
      case QUESTIONIDS.questionOneName:
        return (
          <QuestionOneName
            {...(QuestionData[QUESTIONIDS.questionOneName] as Question)}
          />
        );
      case QUESTIONIDS.questionFourPassengers:
        return (
          <QuestionFourPassenger
            {...(QuestionData[
              QUESTIONIDS.questionFourPassengers
            ] as SliderQuestion)}
          />
        );
      case QUESTIONIDS.questionTwoYourVehicle:
        return (
          <QuestionTwoYourVehicle
            {...(QuestionData[QUESTIONIDS.questionTwoYourVehicle] as Question)}
            nextStepId={QUESTIONIDS.questionThreeVehicleUse}
            setStepManual={setStepManual}
            showResultVehicle={showResultVehicle}
            onShowResultVehicle={onShowResultVehicle}
          />
        );
      case QUESTIONIDS.questionThreeVehicleUse:
        return (
          <QuestionThreeVehicleUse
            {...(QuestionData[
              QUESTIONIDS.questionThreeVehicleUse
            ] as SingleSelectorQuestion)}
          />
        );
      case QUESTIONIDS.questionFiveTowingPreference:
        return (
          <QuestionFiveTowingPreference
            {...(QuestionData[
              QUESTIONIDS.questionFiveTowingPreference
            ] as SingleSelectorQuestion)}
          />
        );
      case QUESTIONIDS.questionSixFitsYourTrade:
        return (
          <QuestionSixFitsYourTrade
            {...(QuestionData[
              QUESTIONIDS.questionSixFitsYourTrade
            ] as SingleSelectorQuestion)}
          />
        );
      case QUESTIONIDS.questionSevenVehicleFeatures:
        return (
          <QuestionSevenVehicleFeaturesLong
            {...(QuestionData[
              QUESTIONIDS.questionSevenVehicleFeatures
            ] as MultiSelectorQuestion)}
            nextStepId={QUESTIONIDS.questionEightAddress}
            result={result as Record<QuestionId, unknown>}
          />
        );
      case QUESTIONIDS.questionEightAddress:
        return (
          <QuestionEightAddress
            {...(QuestionData[
              QUESTIONIDS.questionEightAddress
            ] as MultiSelectorQuestion)}
            nextStepId={QUESTIONIDS.questionNineChargingType}
          />
        );
      case QUESTIONIDS.questionNineChargingType:
        return (
          <QuestionNineChargingType
            {...(QuestionData[
              QUESTIONIDS.questionNineChargingType
            ] as MultiSelectorQuestion)}
            nextStepId={QUESTIONIDS.questionTenChargingHome}
          />
        );
      case QUESTIONIDS.questionTenChargingHome:
        return (
          <QuestionTenChargingHome
            {...(QuestionData[
              QUESTIONIDS.questionTenChargingHome
            ] as SingleSelectorQuestion)}
          />
        );
      case QUESTIONIDS.questionElevenChargingWork:
        return (
          <QuestionElevenChargingWork
            {...(QuestionData[
              QUESTIONIDS.questionElevenChargingWork
            ] as SingleSelectorQuestion)}
          />
        );
      case QUESTIONIDS.questionTwelveTravelDistance:
        return (
          <QuestionTwelveTravelDistance
            {...(QuestionData[
              QUESTIONIDS.questionTwelveTravelDistance
            ] as SliderQuestion)}
            nextStepId={QUESTIONIDS.questionThirteenForm}
          />
        );
      case QUESTIONIDS.questionThirteenForm:
        return (
          <QuestionThirteenForm
            {...(QuestionData[
              QUESTIONIDS.questionThirteenForm
            ] as SliderQuestion)}
            nextStepId={QUESTIONIDS.questionFourteenResults}
          />
        );
      case QUESTIONIDS.questionFourteenResults:
        return (
          <QuestionFourteenResults
            closeDialog={() => {
              onClose && onClose();
              history.push(generateResultsUrl(result, pathname, search));
            }}
          />
        );
      default:
        return (
          <WrapContentCenter>
            <TypographyHeading
              textAlign={TextAlignment.center}
              color={TokenTextColor.inherit}
              tag={TextTag.h3}
              size={'large'}
            >
              {QuestionData[currentQuestion as QuestionId].title}
            </TypographyHeading>
          </WrapContentCenter>
        );
    }
  };
  const handleSelectManual = (data: SelectManualProps) => {
    const existingDataIndex = resultsManual.findIndex(
      (resultManual) => resultManual.id === data.id,
    );

    if (existingDataIndex !== -1) {
      setResultsManual((prevResultsManual) => {
        const newResults = [...prevResultsManual];
        newResults[existingDataIndex] = data;
        return newResults;
      });
    } else {
      setResultsManual((prevResultsManual) => [...prevResultsManual, data]);
    }
  };
  const handleResetQuestion = () => {
    setStepManual(1);
    setResultsManual([]);
  };
  const handleNextStep = () => {
    if (stepManual < 5) {
      setStepManual(stepManual + 1);
      setQuestionHistory(currentQuestion, `manual-step-${stepManual + 1}`);
    } else {
      setCurrentQuestion(QUESTIONIDS.questionThreeVehicleUse, false);
      setQuestionType('Question');
    }
  };
  const handlePreviousStep = () => {
    if (stepManual > 1) {
      setStepManual(stepManual - 1);
    }
  };
  const currentQuestionManual = questionsManual[stepManual - 1];
  const goBackManual = () => {
    (stepManual === 4 &&
      result?.q2_your_vehicle?.rego &&
      result?.q2_your_vehicle?.state) ||
    stepManual === 1
      ? setQuestionType('Question')
      : handlePreviousStep();

    if (stepManual === 1) {
      setResultsManual([]);
    }

    popQuestionHistory();
  };
  const skipQuestionManual = () => {
    setCurrentQuestion(QUESTIONIDS.questionThreeVehicleUse, false);
    setQuestionType('Question');
  };

  function onTapGoBack() {
    const previousQuestionHistory = questionHistory[questionHistory.length - 1];

    if (!previousQuestionHistory) return;
    const [questionId, identifier] = parseQuestionIdWithIdentifier(
      previousQuestionHistory,
    );

    // Change the question type to manual if the previous question is manual
    if (currentQuestion === QUESTIONIDS.questionTwoYourVehicle) {
      if (!showResultVehicle) setCurrentQuestion(questionId, false);
      if (showResultVehicle) {
        onHiddenResultVehicle();
        setCurrentQuestion(currentQuestion);
      }
    }
    if (currentQuestion === QUESTIONIDS.questionThreeVehicleUse) {
      if (
        result.q2_your_vehicle &&
        result.q2_your_vehicle.rego &&
        result.q2_your_vehicle.state
      ) {
        onShowResultVehicle();
        setCurrentQuestion(questionId, false);
      } else {
        onHiddenResultVehicle();
        setCurrentQuestion(questionId, false);
      }
    }
    if (identifier.startsWith('manual-step-')) {
      const lastStep = Number(identifier.replace('manual-step-', ''));
      setQuestionType('Manual');
      setQuestionHistory(questionId, identifier);
      setCurrentQuestion(questionId, false);
      setStepManual(lastStep);
      popQuestionHistory();
      return;
    }
    goBack();
  }

  return (
    <QuestionContainer>
      <QuestionCloseDialog
        open={isShowCloseDialog}
        onConfirm={() => {
          setIsShowCloseDialog(false);
          onClose?.();
          history.goBack();
        }}
        onCancel={() => {
          setIsShowCloseDialog(false);
        }}
      />
      {questionType === 'Question' && (
        <>
          <Header style={{alignItems: 'center'}}>
            <BackButtonSVG
              onClick={() => {
                currentQuestion === QUESTIONIDS.questionLanding
                  ? setIsShowCloseDialog(true)
                  : onTapGoBack();
              }}
            />
            {currentQuestion !== QUESTIONIDS.questionLanding && (
              <ProgressBar
                value={
                  QuestionData[currentQuestion as QuestionId]?.progressValue
                }
                max={100}
              />
            )}
            <CloseButtonSVG
              onClick={() => {
                setIsShowCloseDialog(true);
              }}
              style={{
                right: '0px',
              }}
            />
          </Header>
          {renderQuestionMain(currentQuestion)}
        </>
      )}

      {questionType === 'Manual' && (
        <QuestionManual
          goBackManual={goBackManual}
          currentQuestionManual={currentQuestionManual}
          skipQuestionManual={skipQuestionManual}
          handleNextStepManual={handleNextStep}
          handleSelectManual={handleSelectManual}
          handleResetQuestion={handleResetQuestion}
          resultsManual={resultsManual}
        />
      )}
    </QuestionContainer>
  );
};

export default QuestionModal;
